import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WhatsInTheBoxService {
  private subject = new Subject<boolean>();

  dispatchHasContent(event: boolean) {
    this.subject.next(event);
  }

  hasContent(): Observable<any> {
    return this.subject.asObservable();
  }
}
